<section class="page-404 content-block--noHead content-block--grid">
    <div class="page-404__container">
        <h1 class="page-404__title">Vous cherchez quelque chose ?</h1>
        <h2 class="page-404__subtitle">
            Vous trouverez assurément en cliquant
            <a class="page-404__subtitleLink" href="" routerLink="/">ici</a>
        </h2>
    </div>
</section>
